/* eslint-disable max-len */
// Copyright (c) 2016 Deere & Company

import { getColumnSeparator } from './get-column-separator';
import { getDateFormat } from './get-date-format';
import moment from 'moment';
import { getFormattedCellValues as processCellCallback } from './reports';

export const exportToCSV = (fileName, gridApi) => {

    const columnSeparator = getColumnSeparator(1);

    const timeStamp = moment.utc().format(getDateFormat(2));

    const exportToCsvParams = {
        columnSeparator,
        fileName: `${fileName}-${timeStamp}.csv`,
        processCellCallback,
    };

    gridApi.exportDataAsCsv(exportToCsvParams);

};
